var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPlaneGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.99149624,4.6075679 L11.8585239,3.33333338 L12.0000002,3.33333338 C14.2205386,3.33333338 15.3333336,3.61153213 15.3333336,4.66666674 C15.3333336,5.4608706 14.1889019,6.41656934 11.5577735,8.10153198 L9.86037976,13.1937132 L6.5084074,14.3110374 L7.14478517,10.1745818 C6.81010162,10.3422893 6.53089145,10.4820772 6.30714249,10.5939517 C6.08445258,10.7052967 5.91658668,10.7890486 5.80335985,10.8452989 C5.72490937,10.8842282 5.72490937,10.8842282 5.67258486,10.9099907 C5.66050394,10.9171867 5.6548134,10.9205763 5.63006453,10.9303236 C3.99333392,11.7477581 2.25095894,10.9988334 1.39365487,9.25116677 L0.547617833,7.17101514 L1.88413285,5.85657911 L4.00083894,6.92089137 L4.7114853,6.56556818 L3.00000004,5.34307869 L3.00000004,3.92131073 L4.97476323,2.93392913 L8.99149624,4.6075679 Z M12.1403652,4.66716054 L9.00850403,6.05909875 L5.02523686,4.39940421 L4.40616182,4.70894171 L7.28851484,6.76776516 L3.99916109,8.41244192 L2.13826353,7.47675418 L2.60947931,8.70588399 C3.14062577,9.78632535 4.10663621,10.2013256 5.03519095,9.7370483 L5.16602525,9.68800183 C5.03512209,9.73500955 5.03512209,9.73500955 5.08529024,9.71296768 C5.13337546,9.68929269 5.13337546,9.68929269 5.21014026,9.65120112 C5.32213565,9.59556256 5.48910309,9.51225891 5.71085764,9.40138165 C6.15498847,9.17931625 6.81842718,8.84687494 7.70107802,8.40410549 L8.85525998,7.82512626 L8.15825947,12.3556293 L8.80628718,12.1396201 L10.4423938,7.23130061 L10.6420832,7.10422554 C11.8439083,6.33942776 12.7409134,5.71424248 13.3278417,5.2340284 C13.5269199,5.07114626 13.6870423,4.92749969 13.8068529,4.80579065 C13.4460221,4.72069767 12.8862615,4.67248297 12.1403652,4.66716054 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset-Artboard-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_plane"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "shape",
    fill: "#B2B2B2",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPlaneGray);
export default __webpack_public_path__ + "static/media/ico_plane-gray.a244c6001425d99a5a08908921cdd7b9.svg";
export { ForwardRef as ReactComponent };